import { db } from "../firebase";
import firebase from "firebase/compat/app";

// Si el usuario no definió preferencia para la categoría, se asume
// habilitada (opt-out, no opt-in) para no romper el comportamiento previo.
export const shouldNotify = async (userId, category) => {
  try {
    const snap = await db.doc(`users/${userId}`).get();
    const prefs = snap.exists ? snap.data()?.notificationPrefs : null;
    if (!prefs) return true;
    // "push" es el interruptor maestro (Notificaciones > Notificaciones push):
    // si está apagado, no se crea la notificación para ninguna categoría.
    if (prefs.push === false) return false;
    if (!(category in prefs)) return true;
    return prefs[category] !== false;
  } catch (error) {
    console.error("Error checking notification preference:", error);
    return true;
  }
};

// Crea una notificación para `userId` (el destinatario) si tiene habilitada
// la categoría correspondiente. `companyId` es quien dispara el evento
// (quien sigue, quien compra, etc.), igual que en el resto de la colección
// "notifications". No se notifica a uno mismo.
export const notifyUser = async ({ userId, companyId, category, type, message, postId }) => {
  if (!userId || userId === companyId) return;
  const allowed = await shouldNotify(userId, category);
  if (!allowed) return;
  try {
    await db.collection("notifications").add({
      userId,
      companyId,
      type,
      message,
      postId: postId || "",
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      read: false,
    });
  } catch (error) {
    console.error("Error creating notification:", error);
  }
};

// Avisa a todos los seguidores de `ownerUid` (lee companyFollowers/{ownerUid},
// mismo esquema que members.js/perfil.js usan para seguir cuentas). Cada
// destinatario pasa igual por su propia preferencia via notifyUser.
export const notifyFollowers = async ({ ownerUid, category, type, message, postId }) => {
  if (!ownerUid) return;
  try {
    const followersSnap = await db.doc(`companyFollowers/${ownerUid}`).get();
    if (!followersSnap.exists) return;
    const followerIds = Object.keys(followersSnap.data() || {});
    await Promise.all(
      followerIds.map((followerId) =>
        notifyUser({ userId: followerId, companyId: ownerUid, category, type, message, postId })
      )
    );
  } catch (error) {
    console.error("Error notifying followers:", error);
  }
};
